import { Box } from '@customerio/pluma-components/react';

/** Email-verification step. Placeholder — content lands with FPS-2859. */
export function ConfirmationStep() {
  return <Box data-testid="signup-step-confirmation" />;
}
